import { useMediaQuery } from "@mui/system";
import { erasmusRequests } from "api/erasmusApi";
import { studentRequests } from "api/studentApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { Datagrid, List, ReferenceField, ShowButton, SimpleList, TextField } from "react-admin";
import { EmptyList } from "server/components";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  return (
    <List
      title="Списък кампании"
      sx={settings.style.blockStyle}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на кампанията", value: record?.name }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Академична година",
                    value: (
                      <ReferenceField
                        reference={studentRequests.getAcademicYearsSelect()}
                        label="Академична година"
                        source="academicYearId"
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Сезон",
                    value: (
                      <ReferenceField
                        reference={erasmusRequests.getCampaignSeasonsSelect()}
                        label="Сезон"
                        source="campaignSeason"
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => <ShowButton label="" />}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            label="Име на кампанията"
            source="name"
            sortable={false}
          />

          <ReferenceField
            reference={studentRequests.getAcademicYearsSelect()}
            label="Академична година"
            source="academicYearId"
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            reference={erasmusRequests.getCampaignSeasonsSelect()}
            label="Сезон"
            source="campaignSeason"
          >
            <TextField source="nameBg" />
          </ReferenceField>

          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListCampaigns;
